// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Db from "./Db.bs.jsx";
import * as React from "react";
import * as Reactfire from "reactfire";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Functions from "firebase/functions";

let isMobileIOs = (navigator.userAgent.match(/(iPhone|iPad)/));

let canSubscribe = ("Notification" in window) && (!isMobileIOs || (window.navigator.standalone === true));

function useGetSubscibedUsers(currentUserUid, event, place) {
  return React.useMemo(() => Stdlib_Array.filterMap(Object.entries(place.accounts), param => {
    let uid = param[0];
    if (uid === currentUserUid || (param[1][1] & event) === 0) {
      return;
    } else {
      return uid;
    }
  }), [
    currentUserUid,
    event,
    place
  ]);
}

function useDispatchFreeTableNotification(currentUserUid, place, recentConsumptionsByUser) {
  let firestore = Reactfire.useFirestore();
  let functions = Reactfire.useFunctions();
  let dispatchNotification = Functions.httpsCallable(functions, "dispatchNotification");
  let subscribedUsers = useGetSubscibedUsers(currentUserUid, 1, place);
  let freeTableSituation = React.useMemo(() => {
    if (subscribedUsers.length !== 0) {
      return Array.from(recentConsumptionsByUser.values()).every(consumptions => consumptions.length === 0);
    } else {
      return false;
    }
  }, [
    recentConsumptionsByUser,
    subscribedUsers
  ]);
  return () => {
    if (!freeTableSituation) {
      return;
    }
    let placeRef = Db.placeDocument(firestore, Db.getUid(place));
    dispatchNotification({
      TAG: 1,
      place: placeRef.path,
      users: subscribedUsers
    });
  };
}

function useDispatchFreshKegNotification(currentUserUid, place) {
  let firestore = Reactfire.useFirestore();
  let functions = Reactfire.useFunctions();
  let dispatchNotification = Functions.httpsCallable(functions, "dispatchNotification");
  let subscribedUsers = useGetSubscibedUsers(currentUserUid, 2, place);
  return keg => {
    let freshKegSituation = subscribedUsers.length !== 0 && keg.consumptionsSum === 0;
    if (!freshKegSituation) {
      return;
    }
    let kegRef = Db.kegDoc(firestore, Db.getUid(place), Db.getUid(keg));
    dispatchNotification({
      TAG: 2,
      keg: kegRef.path,
      users: subscribedUsers
    });
  };
}

function useDispatchTestNotification(currentUserUid, place) {
  let firestore = Reactfire.useFirestore();
  let functions = Reactfire.useFunctions();
  let dispatchNotification = Functions.httpsCallable(functions, "dispatchNotification");
  return () => {
    let placeRef = Db.placeDocument(firestore, Db.getUid(place));
    dispatchNotification({
      TAG: 1,
      place: placeRef.path,
      users: [currentUserUid]
    });
  };
}

function useUpdateNotificationToken() {
  let functions = Reactfire.useFunctions();
  let updateDeviceToken = Functions.httpsCallable(functions, "updateNotificationToken");
  return deviceToken => updateDeviceToken({
    deviceToken: deviceToken
  });
}

export {
  isMobileIOs,
  canSubscribe,
  useGetSubscibedUsers,
  useDispatchFreeTableNotification,
  useDispatchFreshKegNotification,
  useDispatchTestNotification,
  useUpdateNotificationToken,
}
/* isMobileIOs Not a pure module */
